import React from 'react';
import { useItems } from '../../../hooks/useItems';
import { ItemGrid } from './ItemGrid';
import type { User } from '../../../types/user';

interface ItemInventoryProps {
  user: User | null;
}

export function ItemInventory({ user }: ItemInventoryProps) {
  const { userItems, loading, error } = useItems(user?.walletAddress);

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Please log in to view your items</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-400 text-center py-12">
        {error}
      </div>
    );
  }

  if (userItems.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Your treasury is empty. Visit the marketplace to acquire items!</p>
      </div>
    );
  }

  return <ItemGrid items={userItems} />;
}